<template>
  <section class="catalog-index">
    <div class="container">
      <h1 class="catalog-index__title">Каталог</h1>

      <div class="catalog-index__grid">
        <template
          v-for="(category, index) in categories"
          :key="`catalog-category-${category.id}`"
        >
          <CategoryChildrenCard
            :category="category"
          />
        </template>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { catalogStore } from '#sitis/stores/modules/catalog-store';
import CategoryChildrenCard from "~/components/catalog/CategoryChildrenCard.vue";

const storeCatalog = catalogStore();

const categories = computed(() => {
  let categories = storeCatalog?.$state?.categories || [];
  categories = categories.map((item: any) => ({
    ...item,
    items: (item?.items || []).filter((t: any) => t?.showInMenu)
  }))
    .filter((t: any) => t?.showInMenu)
    .filter((t: any) => t.depth < 3);

  let list: any = categories.filter((t) => t.depth === 1);
  list = list.map((item: any) => ({
    ...item,
    children: categories.filter((t: any) => t.parentId === item.id)
  }));

  return list
});

useHead(() => {
  const rootCategory = (storeCatalog.$state?.categories || []).find((t: any) =>  t.depth === 0);

  let head: any = {
    title: '',
    meta: [],
    link: [],
  };

  const title = rootCategory?.title;
  if (title) {
    head.title = title;
    head.meta.push({name: 'og:title', hid: "og:title", property: "og:title", content: title},)
  }

  const description = rootCategory?.shortDescription || "";
  if (!!description) {
    head.meta.push({
      hid: 'metadescription',
      name: 'description',
      content: description
    })
    head.meta.push({
      name: 'og:description',
      hid: "og:description",
      property: "og:description",
      content: description
    })
  }

  return head
});
</script>

<style scoped lang="scss">
.catalog-index {}
.catalog-index__title {
  margin-bottom: 24px;
}
.catalog-index__grid {
  display: flex;
  flex-wrap: wrap;
  margin-top: -64px;
  margin-left: -20px;

  & > * {
    width: calc(100% / 5 - 20px);
    margin-top: 64px;
    margin-left: 20px;
  }
}

@media (max-width: 1699px) {
  .catalog-index__grid > * {
    width: calc(100% / 4 - 20px);
  }
}
@media (max-width: 1359px) {
  .catalog-index__grid > * {
    width: calc(100% / 3 - 20px);
  }
}
@media (max-width: 1023px) {
  .catalog-index {
    padding-top: 32px;
    box-sizing: border-box;
  }
  .catalog-index__breadcrumbs {
    display: none;
  }
  .catalog-index__title {
    margin-bottom: 16px;
  }
  .catalog-index__grid {
    margin-top: -20px;
    & > * {
      width: calc(50% - 20px);
      margin-top: 20px;
    }
  }
}
@media (max-width: 859px) {
  .catalog-index__grid {
    margin-top: -16px;
    margin-left: 0;
    & > * {
      width: 100%;
      margin-top: 16px;
      margin-left: 0;
    }
  }
}
</style>
